import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=0825d91a&"
import script from "./PersonForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./PersonForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PersonForm.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports